import React, { useEffect, useRef } from "react";
// import "../styles/Header.scss";
import { ReactComponent as HereWeAreLogo } from "../assets/header/hereweare_logo.svg";
import { useBreakpoint } from "../../../shared/utils/hooks/useBreakpoint";
import clsx from "clsx";

const Header = () => {
  // const [downloadMenuShowState, setDownloadMenuShowState] = useState(false);
  // let mobileMenuRef = useRef<0 | 1>(0);
  // let animation = useRef<boolean>(false);
  // let mobileMenuAction: () => void = () => {};

  // const tl = gsap.timeline({
  //   onComplete: () => {
  //     tl.kill();
  //   },
  // });

  // mobileMenuAction = () => {
  //   if (animation.current) return;
  //   animation.current = true;
  //   const newState = mobileMenuRef.current === 1 ? 0 : 1;
  //   const newsrc = newState === 1 ? "icon_close.svg" : "icon_menu.svg";
  //   tl.to(".mobileMenu", {
  //     yPercent: newState * 100,
  //     duration: 0.75,
  //     ease: "power1.inOut",
  //   })
  //     .to(".mobileMenuButton img", { duration: 0.3, opacity: 0.4 }, "<")
  //     .to(".mobileMenuButton img", {
  //       content: `url("/header/${newsrc}")`,
  //       opacity: 1,
  //       duration: 0.45,
  //     });
  //   mobileMenuRef.current = newState;
  //   animation.current = false;
  // };

  // useEffect(() => {
  //   tl.from(".mobileMenu", { yPercent: mobileMenuRef.current * 100 });
  //   tl.clear();
  // });

  const { mobileMode } = useBreakpoint();
  const logoRef = useRef<HTMLDivElement>(null);
  const MIN_SCALE = mobileMode ? 0.3 : 0.2;
  const MAX_SCROLL = 1600;

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const rawScale = 1 - scrollY / MAX_SCROLL;
      const scale = Math.max(MIN_SCALE, Math.min(1, rawScale));
      const marginTop = 12 * (1 - scale);

      if (logoRef.current) {
        logoRef.current.style.transform = `scale(${scale})`;
        logoRef.current.style.marginTop = `${marginTop}px`;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <header className="sticky top-0 z-50 w-ful h-12">
        <div
          ref={logoRef}
          className={clsx(
            "transition-all",
            mobileMode ? "duration-0" : "duration-300"
          )}
          style={{
            transformOrigin: "top center",
          }}
        >
          <HereWeAreLogo className="w-full h-full" width="100%" height="100%" />
        </div>
      </header>
      {/* <header className="header">
        <div className="container">
          <div className="logoContainer">
            <img className="logo icon"></img>
            <img className="logo text"></img>
          </div>
          <div className="menuContainer">
            <div className="webMenuButton">
              <button>
                <a href="/hereweare101" target="_blank">
                  HWA 101
                </a>
              </button>
              <button className="downloadButton">
                <div
                  className="download"
                  onClick={() =>
                    setDownloadMenuShowState(!downloadMenuShowState)
                  }
                >
                  <h3>Download</h3>
                  <ExtIcon />
                </div>
                <div
                  className={`downloadHiddenMenu ${
                    downloadMenuShowState ? "show" : ""
                  }`}
                >
                  <a href="https://play.google.com/store/apps/details?id=com.hsoft.hwa">
                    <GoogleDownloadIcon />
                  </a>
                  <a href="https://apps.apple.com/us/app/hereweare-livespot-connections/id1491869024?ls=1">
                    <AppleDownloadIcon />
                  </a>
                </div>
              </button>
            </div>
            <div className="mobile">
              <button className="mobileMenuButton" onClick={mobileMenuAction}>
                <img />
              </button>
            </div>
          </div>
        </div>
        <ScrollProgress />
      </header> */}
      {/* <div className="mobileMenu">
        <ul>
          <li></li>
          <li>
            <a href="/">
              <h3>LiveSpots</h3>
            </a>
          </li>
          <li>
            <a href="/">
              <h3>Download</h3>
            </a>
            <div className="buttons">
              <a href="https://apps.apple.com/us/app/hereweare-livespot-connections/id1491869024?ls=1">
                <AppleDownloadIcon />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.hsoft.hwa">
                <GoogleDownloadIcon />
              </a>
            </div>
          </li>
        </ul>
      </div> */}
    </>
  );
};

export default Header;
